"use client";

import styled from "styled-components";

//Components
import Image from "../image";

export const ImageTable = styled(Image)`
  width: 50px;
  height: 50px;
  border-radius: 50px;
  object-fit: cover;
  border: 1px solid var(--border);
`;
